import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ButtonDirective,
  ModalCloseButtonDirective,
  ModalComponent,
  ModalContentDirective,
  ModalTitleDirective,
  SizeScheme
} from '@bioreferencehealth/ui-kit';
import { ReloadService } from 'src/app/services/reload.service';

@Component({
  standalone: true,
  selector: 'app-chunk-load-error-modal',
  templateUrl: './chunk-load-error-modal.component.html',
  styleUrls: ['./chunk-load-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ButtonDirective, ModalTitleDirective, ModalContentDirective, ModalCloseButtonDirective]
})
export class ChunkLoadErrorModalComponent {
  private readonly reloadService = inject(ReloadService);

  public readonly SizeScheme = SizeScheme;

  public onRefresh(): void {
    this.reloadService.reload();
  }
}
